import types from "./types"

const setOperatorDisabled = (operatorAutoDisabled = {}) => ({
  type: types.OPERATOR_DISABLED_SET,
  operatorAutoDisabled
})

export default {
  setOperatorDisabled
}